export enum TestimonialColumnCount {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Auto = 'auto'
}
